module.exports = __webpack_public_path__ + "img/128.79c31ce5.jpg";